// extracted by mini-css-extract-plugin
module.exports = {"icon-warning":"icon-warning___38LxP","title":"title___qEMqw"};